/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ExternalReceiptBulkDeleteRequest,
  ExternalReceiptBulkDownloadRequest,
  ExternalReceiptBulkLinkRequest,
  ExternalReceiptDescriptorFilterRequest,
  ExternalReceiptLinkRequest,
  ExternalReceiptUploadBulkResultDto,
  InvoiceDescriptorBulkDeleteRequest,
  InvoiceDescriptorFilterRequest,
  NumberOfUnattachedReceipts,
  PageExternalReceiptDescriptorInboxDto,
  PageInvoiceFileDescriptorDto,
  UploadReceiptFilesParams,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiUniversalInboxController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name ConvertInvoiceToReceipt
   * @request POST:/api/v1/universal-inbox/invoice/{invoiceDescriptorId}/to-receipt
   */
  convertInvoiceToReceipt = (invoiceDescriptorId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/universal-inbox/invoice/${invoiceDescriptorId}/to-receipt`,
      method: 'POST',
      ...params,
    })

  static convertInvoiceToReceiptPath =
    '/v1/universal-inbox/invoice/${invoiceDescriptorId}/to-receipt'
  static convertInvoiceToReceiptMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name GetAllInvoiceDescriptors
   * @request POST:/api/v1/universal-inbox/invoice/paged
   */
  getAllInvoiceDescriptors = (data: InvoiceDescriptorFilterRequest, params: RequestParams = {}) =>
    this.http.request<PageInvoiceFileDescriptorDto, any>({
      path: `/v1/universal-inbox/invoice/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getAllInvoiceDescriptorsPath = '/v1/universal-inbox/invoice/paged'
  static getAllInvoiceDescriptorsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name BulkDeleteInvoices1
   * @request POST:/api/v1/universal-inbox/invoice/bulk-delete
   */
  bulkDeleteInvoices = (data: InvoiceDescriptorBulkDeleteRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/universal-inbox/invoice/bulk-delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkDeleteInvoicesPath = '/v1/universal-inbox/invoice/bulk-delete'
  static bulkDeleteInvoicesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name ConvertReceiptToInvoice
   * @request POST:/api/v1/universal-inbox/external-receipts/{externalReceiptId}/to-invoice
   */
  convertReceiptToInvoice = (externalReceiptId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/universal-inbox/external-receipts/${externalReceiptId}/to-invoice`,
      method: 'POST',
      ...params,
    })

  static convertReceiptToInvoicePath =
    '/v1/universal-inbox/external-receipts/${externalReceiptId}/to-invoice'
  static convertReceiptToInvoiceMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name GetExternalReceiptsInboxForUser
   * @request POST:/api/v1/universal-inbox/external-receipts/user/paged
   */
  getExternalReceiptsInboxForUser = (
    data: ExternalReceiptDescriptorFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PageExternalReceiptDescriptorInboxDto, any>({
      path: `/v1/universal-inbox/external-receipts/user/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getExternalReceiptsInboxForUserPath = '/v1/universal-inbox/external-receipts/user/paged'
  static getExternalReceiptsInboxForUserMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name UploadReceiptFiles
   * @request POST:/api/v1/universal-inbox/external-receipts/upload-files
   */
  uploadReceiptFiles = (query: UploadReceiptFilesParams, params: RequestParams = {}) =>
    this.http.request<ExternalReceiptUploadBulkResultDto, any>({
      path: `/v1/universal-inbox/external-receipts/upload-files`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    })

  static uploadReceiptFilesPath = '/v1/universal-inbox/external-receipts/upload-files'
  static uploadReceiptFilesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name GetExternalReceiptsInbox
   * @request POST:/api/v1/universal-inbox/external-receipts/paged
   */
  getExternalReceiptsInbox = (
    data: ExternalReceiptDescriptorFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PageExternalReceiptDescriptorInboxDto, any>({
      path: `/v1/universal-inbox/external-receipts/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getExternalReceiptsInboxPath = '/v1/universal-inbox/external-receipts/paged'
  static getExternalReceiptsInboxMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name LinkExternalReceiptToTransaction
   * @request POST:/api/v1/universal-inbox/external-receipts/link
   */
  linkExternalReceiptToTransaction = (
    data: ExternalReceiptLinkRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/universal-inbox/external-receipts/link`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static linkExternalReceiptToTransactionPath = '/v1/universal-inbox/external-receipts/link'
  static linkExternalReceiptToTransactionMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name BulkLinkExternalReceiptToTransaction
   * @request POST:/api/v1/universal-inbox/external-receipts/bulk-link
   */
  bulkLinkExternalReceiptToTransaction = (
    data: ExternalReceiptBulkLinkRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/universal-inbox/external-receipts/bulk-link`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkLinkExternalReceiptToTransactionPath =
    '/v1/universal-inbox/external-receipts/bulk-link'
  static bulkLinkExternalReceiptToTransactionMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name StreamDownloadOrganisationReceiptsGrouped
   * @request POST:/api/v1/universal-inbox/external-receipts/bulk-download
   */
  streamDownloadOrganisationReceiptsGrouped = (
    data: ExternalReceiptBulkDownloadRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/universal-inbox/external-receipts/bulk-download`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static streamDownloadOrganisationReceiptsGroupedPath =
    '/v1/universal-inbox/external-receipts/bulk-download'
  static streamDownloadOrganisationReceiptsGroupedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name BulkDeleteExternalReceipt
   * @request POST:/api/v1/universal-inbox/external-receipts/bulk-delete
   */
  bulkDeleteExternalReceipt = (
    data: ExternalReceiptBulkDeleteRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/universal-inbox/external-receipts/bulk-delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkDeleteExternalReceiptPath = '/v1/universal-inbox/external-receipts/bulk-delete'
  static bulkDeleteExternalReceiptMethod = 'POST'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name DownloadExternalReceiptFile
   * @request GET:/api/v1/universal-inbox/external-receipts/{externalReceiptId}/file/download
   */
  downloadExternalReceiptFile = (externalReceiptId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/universal-inbox/external-receipts/${externalReceiptId}/file/download`,
      method: 'GET',
      ...params,
    })

  static downloadExternalReceiptFilePath =
    '/v1/universal-inbox/external-receipts/${externalReceiptId}/file/download'
  static downloadExternalReceiptFileMethod = 'GET'
  /**
   * No description
   *
   * @tags api-universal-inbox-controller
   * @name GetNumberOfUnlinkedReceipts
   * @request GET:/api/v1/universal-inbox/external-receipts/unlinked
   */
  getNumberOfUnlinkedReceipts = (params: RequestParams = {}) =>
    this.http.request<NumberOfUnattachedReceipts, any>({
      path: `/v1/universal-inbox/external-receipts/unlinked`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getNumberOfUnlinkedReceiptsPath = '/v1/universal-inbox/external-receipts/unlinked'
  static getNumberOfUnlinkedReceiptsMethod = 'GET'
}
